/*
 * Bridge between the site and the Afterpay app's gift card checkout webview.
 * Message types must match the switch in afterpay-mobile's
 * giftCardCheckoutWebview.tsx exactly — the mixed casing is intentional.
 */
export const WEBVIEW_MESSAGE_TYPES = {
    SHOW_CLOSE_BUTTON: "showCloseButton",
    ON_GIFT_CARD_CLOSE: "onGiftCardClose",
    OPEN_DEEP_LINK: "OPEN_DEEP_LINK",
} as const;

export type WebviewMessageType = typeof WEBVIEW_MESSAGE_TYPES[keyof typeof WEBVIEW_MESSAGE_TYPES];

/*
 * Optional payload for ON_GIFT_CARD_CLOSE. By the time a terminal screen is shown the
 * checkout URL carries status=SUCCESS, which the app resolves to "pop to the gift card
 * wall". GIFT_CARD asks instead for a plain goBack() to the gift card order screen
 * directly beneath the webview (afterpay-mobile giftCardCheckoutWebview.tsx,
 * isReturnToGiftCardClose). App builds without that handler ignore the payload and
 * fall back to today's behaviour, so it is safe to send unconditionally.
 */
export const GIFT_CARD_CLOSE_DESTINATIONS = {
    GIFT_CARD: "giftCard",
} as const;

export const postToApp = (type: WebviewMessageType, payload: unknown = {}): void => {
    if (typeof window === "undefined") {
        return;
    }
    window.AfterpayReactNativeWebView?.postMessage(JSON.stringify({ type, payload }));
};
